import styled from "styled-components";
import { NavAndFeesCard, } from "./components/NavAndFeesCard";
import { VanityCard, } from "./components/VanityCard";
import { Grid, } from "@bracket/ui";



export const MiddleSection: React.FC = () => {
	return (
		<Container>
			<NavAndFeesCard />
			<VanityCard />
		</Container>
	);
};


const Container = styled(Grid)`
	display: grid;
	grid-template-rows: repeat(2, min-content);
	gap: 32px;
	@media (min-width: 768px) {
		grid-template-columns: 1.5fr 1fr;
		grid-template-rows: 1fr;
		gap: 24px;
	}
`;

